import { useRef } from "react";
import ModalPop from "../../home/ModalPop";
import menuOnClick from "../menuOnClick";

const MobileQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div className="block xl:hidden fixed left-0 bottom-0 w-full h-fit bg-white border rounded-t-2xl z-40">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="relative w-full h-fit grid grid-cols-5 justify-items-center text-center pt-1.5">
        <button type="button" onClick={openfunc}>
          <img
            src="/images/iconContact.png"
            alt="무료 견적문의"
            width={40}
            height={40}
            className="mx-auto"
          />
          <small>견적문의</small>
        </button>
        <button type="button" onClick={() => menuOnClick("#review")}>
          <img
            src="/images/iconReview.png"
            alt="작업사례 보기"
            width={45}
            height={45}
            className="mx-auto"
          />
          <small>작업사례</small>
        </button>

        <button type="button" onClick={openfunc}>
          <img
            src="/images/iconBlog.png"
            alt="상담하기"
            width={25}
            height={25}
            className=" opacity-0"
          />
          <p>상담하기</p>
        </button>
        <button
          type="button"
          onClick={() => (window.location.href = "tel:010-8245-7949")}
          className="absolute bottom-1/2 left-1/2 -translate-x-8 w-16 h-16 rounded-full bg-white grid items-center justify-items-center boxshadow cursor-pointer"
        >
          <img
            src="/images/iconCall.png"
            alt="전화 상담 010-8245-7949"
            width={50}
            height={50}
            className="mx-auto"
          />
        </button>
        <button
          type="button"
          onClick={() => window.open("https://blog.naver.com/jewde101")}
        >
          <img
            src="/images/iconBlog.png"
            alt="네이버 블로그 바로가기"
            width={40}
            height={40}
            className="mx-auto"
          />
          <small>블로그</small>
        </button>
        <button
          type="button"
          onClick={() => window.open("https://open.kakao.com/o/shFXA18h")}
        >
          <img
            src="/images/iconKakao.png"
            alt="카카오톡 상담 바로가기"
            width={40}
            height={40}
            className="mx-auto"
          />
          <small>카톡상담</small>
        </button>
      </div>
    </div>
  );
};

export default MobileQuick;
